const endPoints = {
  //auth
  LOGIN: "/sign-in",
  REGISTER: "/register",
  REQUEST_OTP: "/request-otp",
  VERIFY_OTP: "/verify-otp",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",

  //user
  MY_PROFILE: "/my-profile",
  PROFILE_UPDATE: "/update",
  SINGLE_FILE_UPL: "/file-upload",

  //Project
  PROJECT: "/project",
  PROJECT_LIST: "/projects",
  FAVROITE_PROJECT: "/project/toggle-favorite",
  UPLOAD_AGREEMENT: "/project/upload-agreement",

  //
  CREATE_CONTRACT: "/contract",
  CONTRACT_LIST: "/contracts/",
  CONTRACT_DETAILS: "/contract",
  SAVE_DOCUMENT: "/save-document",
  SIGN_CONTRACT: "/sign",
  SHARE_CONTRACT: "/share-contract"
};

export default endPoints